export default class BankData {

	constructor() {
		this.id = 0;
		this.bankId = 0;
		this.agency = '';
		this.account = '';
	}
}